import { styled } from 'styled-components';

import { colors, fontSizes, spacing } from '#/theme/theme';

export const MobileSearchFilterButtonHolder = styled.div`
  position: relative;
`;

export const FilterBadge = styled.span`
  position: absolute;
  top: -${spacing[4]};
  right: -${spacing[4]};
  min-width: 18px;
  height: 18px;
  padding: 0 ${spacing[4]};
  border-radius: 9px;
  background-color: ${colors.brandBlue};
  color: ${colors.white};
  font-size: ${fontSizes[12]};
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  pointer-events: none;
`;
